var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13102_1683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13102_1683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 10.3833C7.91107 10.3833 7.82774 10.3694 7.74996 10.3417C7.67218 10.3139 7.59996 10.2667 7.53329 10.2L5.13329 7.8C4.99996 7.66667 4.93607 7.51112 4.94163 7.33334C4.94718 7.15556 5.01107 7 5.13329 6.86667C5.26663 6.73334 5.42496 6.66389 5.60829 6.65834C5.79163 6.65278 5.94996 6.71667 6.08329 6.85L7.33329 8.10001V3.33334C7.33329 3.14445 7.39718 2.98612 7.52496 2.85834C7.65274 2.73056 7.81107 2.66667 7.99996 2.66667C8.18885 2.66667 8.34718 2.73056 8.47496 2.85834C8.60274 2.98612 8.66663 3.14445 8.66663 3.33334V8.10001L9.91663 6.85C10.05 6.71667 10.2083 6.65278 10.3916 6.65834C10.575 6.66389 10.7333 6.73334 10.8666 6.86667C10.9888 7 11.0527 7.15556 11.0583 7.33334C11.0638 7.51112 11 7.66667 10.8666 7.8L8.46663 10.2C8.39996 10.2667 8.32774 10.3139 8.24996 10.3417C8.17218 10.3694 8.08885 10.3833 7.99996 10.3833ZM3.99996 13.3333C3.63329 13.3333 3.3194 13.2028 3.05829 12.9417C2.79718 12.6806 2.66663 12.3667 2.66663 12V10.6667C2.66663 10.4778 2.73051 10.3194 2.85829 10.1917C2.98607 10.0639 3.1444 10 3.33329 10C3.52218 10 3.68051 10.0639 3.80829 10.1917C3.93607 10.3194 3.99996 10.4778 3.99996 10.6667V12H12V10.6667C12 10.4778 12.0638 10.3194 12.1916 10.1917C12.3194 10.0639 12.4777 10 12.6666 10C12.8555 10 13.0138 10.0639 13.1416 10.1917C13.2694 10.3194 13.3333 10.4778 13.3333 10.6667V12C13.3333 12.3667 13.2027 12.6806 12.9416 12.9417C12.6805 13.2028 12.3666 13.3333 12 13.3333H3.99996Z",
    fill: "#7200A0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f43f223a.svg";
export { ForwardRef as ReactComponent };